import { lazy, useEffect } from "react";
import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Toaster } from "react-hot-toast";
import { checkAuth } from "./features/authUserSlice";
import { checkAuthAdmin } from "./features/authAdminSlice";

import PsikotesLayout from "./layout/layoutPsychotes/PsikotesLayout";
import DefaultLayout from "./layout/layoutPsychotes/DefaultLayout";

import PrivateRoute from "./layout/privateRoute/PrivateRoute";
import PrivateRouteAdmin from "./layout/privateRoute/PrivateRouteAdmin";

// Importing pages
import LoginAdmin from "./pages/LoginAdmin";
const LayoutAdmin = lazy(() => import("./layout/layoutAdmin/LayoutAdmin"));
const Layout = lazy(() => import("./layout/layoutUser/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));
const Home = lazy(() => import("./pages/Home"));
const Career = lazy(() => import("./pages/Career"));
const About = lazy(() => import("./pages/AboutUs"));
const PsikotesType = lazy(() => import("./pages/PsikotesType"));
const PsikotesLanding = lazy(() => import("./pages/psychotest/PsychoTesPage"));
const Disc = lazy(() => import("./pages/psychotest/Disc"));
const Msdt = lazy(() => import("./pages/psychotest/Msdt"));
const Istse = lazy(() => import("./pages/psychotest/Istse"));
const Istwa = lazy(() => import("./pages/psychotest/Istwa"));
const Istan = lazy(() => import("./pages/psychotest/Istan"));
const Istge = lazy(() => import("./pages/psychotest/Istge"));
const Istra = lazy(() => import("./pages/psychotest/Istra"));
const Istzr = lazy(() => import("./pages/psychotest/Istzr"));
const Istfa = lazy(() => import("./pages/psychotest/Istfa"));
const Istwu = lazy(() => import("./pages/psychotest/Istwu"));
const Istme = lazy(() => import("./pages/psychotest/Istme"));
const End = lazy(() => import("./pages/psychotest/PsikotesEnd"));

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const user = checkAuth();
    const admin = checkAuthAdmin();

    if (user) {
      dispatch(user);
    }

    if (admin) {
      dispatch(admin);
    }
  }, [dispatch]);

  return (
    <>
      <Toaster />

      <Routes>
        {/* not login */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/type" element={<PsikotesType />} />
        <Route path="/admin/login" element={<LoginAdmin />} />
        <Route element={<DefaultLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/career" element={<Career />} />
        </Route>

        {/* psikotes */}
        <Route path="/psikotes" element={<PsikotesLanding />} />
        <Route path="/psikotes-end" element={<End />} />
        <Route element={<PsikotesLayout />}>
          <Route path="/disc" element={<Disc />} />
          <Route path="/msdt" element={<Msdt />} />
          <Route path="/istse" element={<Istse />} />
          <Route path="/istwa" element={<Istwa />} />
          <Route path="/istan" element={<Istan />} />
          <Route path="/istge" element={<Istge />} />
          <Route path="/istra" element={<Istra />} />
          <Route path="/istzr" element={<Istzr />} />
          <Route path="/istfa" element={<Istfa />} />
          <Route path="/istwu" element={<Istwu />} />
          <Route path="/istme" element={<Istme />} />
        </Route>

        {/* dashboard user */}
        <Route
          path="/app/*"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        />

        {/* dashboard admin */}
        <Route
          path="/admin/*"
          element={
            <PrivateRouteAdmin>
              <LayoutAdmin />
            </PrivateRouteAdmin>
          }
        />

        <Route path="*" element={<Navigate to={"/"} replace />} />
      </Routes>
    </>
  );
}

export default App;
